module.exports = __webpack_public_path__ + "media/images/success-img/layer-5-1081cdc36cf758f0e24b14c49fe96feb.png";